module.exports = __webpack_public_path__ + "img/B14-20190411_03.234c8239.jpg";